var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1580920573319,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2142,
    width: 14,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 938.666667v-85.333334c0-158.464-96.469333-294.698667-233.728-353.322666A234.325333 234.325333 0 0 0 746.666667 320C746.666667 190.634667 641.365333 85.333333 512 85.333333a234.922667 234.922667 0 0 0-234.666667 234.666667c0 72.234667 32.896 136.917333 84.394667 180.010667C224.469333 558.634667 128 694.912 128 853.333333v85.333334h85.333333v-85.333334c0-164.650667 133.973333-298.666667 298.666667-298.666666 164.650667 0 298.666667 134.016 298.666667 298.666666v85.333334h85.333333zM362.666667 320C362.666667 237.653333 429.653333 170.666667 512 170.666667s149.333333 66.986667 149.333333 149.333333S594.346667 469.333333 512 469.333333 362.666667 402.346667 362.666667 320z",
    fill: "currentColor",
    "p-id": 2143
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.9dbda97e.svg";
export { ForwardRef as ReactComponent };